import * as PIXI from 'pixi.js';
import Container = PIXI.Container;

class GameModel {
    public uiContainer: Container;
    public cursorContainer: Container;
    public cannonballsContainer: Container;
    public wallsContainer: Container;
    public cannonsContainer: Container;
    public heldContainer: Container;
}

export default new GameModel();



// WEBPACK FOOTER //
// ./src/game/GameModel.ts